import fetcher from './fetcher';
export default function fetchCurrencyRates() {
    return fetcher({
        url: '/api/v1/currencies/conversion',
        method: 'GET'
    });
}
